module.exports = __webpack_public_path__ + "static/img/gz_android.13b7dad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_android.jpg
// module id = YOUV
// module chunks = 0